export class Subcategory {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new Subcategory (
      this.hash,
      this.name
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/subcategory.ts